import { SavedPathway } from '../types/pathway'

export const savedPathways: SavedPathway[] = [
  {
    id: 'meridian-new-managers',
    name: 'Meridian — New Manager Track',
    organization: 'Meridian Health',
    audience: 'new-manager',
    cohortId: 'meridian-new-mgrs',
    moduleIds: [
      'active-empathetic-listening',
      'adapting-leadership-styles',
      'delegation-empowerment',
      'coaching-for-performance',
      'difficult-conversations',
    ],
    updatedAt: '2026-09-12',
    updatedLabel: 'Updated 2 days ago',
  },
  {
    id: 'northwind-reorg',
    name: 'Northwind — Post-Merger Leadership',
    organization: 'Northwind Logistics',
    audience: 'mid-level',
    cohortId: 'northwind-ops',
    moduleIds: [
      'leading-effective-communication',
      'leading-through-change',
      'communicating-change',
      'managing-resistance',
      'high-performing-teams',
      'stakeholder-management',
    ],
    updatedAt: '2026-09-09',
    updatedLabel: 'Updated 5 days ago',
  },
  {
    id: 'atlas-exec-readiness',
    name: 'Atlas — Executive Readiness',
    organization: 'Atlas Manufacturing',
    audience: 'c-suite',
    cohortId: 'atlas-exec',
    moduleIds: [
      'executive-presence',
      'strategic-decision-making',
      'enhancing-business-outcomes',
      'organizational-transformation',
    ],
    updatedAt: '2026-09-13',
    updatedLabel: 'Updated yesterday',
  },
  {
    id: 'meridian-directors',
    name: 'Meridian — Director Cohort FY26',
    organization: 'Meridian Health',
    audience: 'senior-leader',
    cohortId: 'meridian-directors',
    moduleIds: [
      'reading-leading-room',
      'high-performing-teams',
      'enhancing-business-outcomes',
    ],
    updatedAt: '2026-08-24',
    updatedLabel: 'Updated 3 weeks ago',
  },
]
